<template>
  <div class="autocomplete" id="autocomplete" v-click-outside="onOutsideClick">
    <!-- Input without scope-->
    <div
      v-if="validateProp && scope === ''"
      class="input-wrapper input-field"
      :class="{'error-input' : errors.has(name) && validateField}"
    >
      <input
        type="text"
        :placeholder="placeholder"
        class="input"
        :class="name"
        v-model="search"
        :disabled="!disabledProp"
        @input="onChange"
        @click="onClick"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        @focus.self="clearInputErrors"
        @blur="clearOthers"
        @keydown.tab="onTabClick"
        :name="name"
        v-validate="'required'"
        readonly="readonly"
        autocomplete="off" />
      <span class="icon-wrapper" @click="onClickArrow" :class="name">
        <img class="icon" src='@/assets/images/arrow_down.png' :class="name" />
      </span>
      <img src="@/assets/images/validation_ico.png" alt="" class="icon error-icon" :class="name">
      <div
        v-show="errors.has(name)"
        class="error-tooltip"
        id="errorTooltip"
        :class="{'hide-tooltip' : bluredProp !== name, 'big-size' : bigSize, 'middle-size' : middleSize, 'small-size' : smallSize}">
        <div class="text">
          {{ errors.first(name) }}
        </div>
      </div>
    </div>
    <!-- Input with scope-->
    <div
      v-if="validateProp && scope !== ''"
      class="input-wrapper input-field"
      :class="{'error-input' : errors.has(calculatedScope + name) && validateField}"
    >
      <input
        type="text"
        :placeholder="placeholder"
        class="input"
        :class="name"
        v-model="search"
        :disabled="!disabledProp"
        @input="onChange"
        @click="onClick"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        @focus.self="clearInputErrors"
        @blur="clearOthers"
        @keydown.tab="onTabClick"
        :name="name"
        :data-vv-scope="scope"
        v-validate="'required'"
        data-vv-validate-on="submit"
        :readonly="name !== 'bankInstitution'"
        autocomplete="off" />
      <span class="icon-wrapper" @click="onClickArrow" :class="name">
        <img class="icon" src='@/assets/images/arrow_down.png' :class="name" />
      </span>
      <img src="@/assets/images/validation_ico.png" alt="" class="icon error-icon" :class="name">
      <div
        class="error-tooltip"
        id="errorTooltip"
        v-show="errors.has(calculatedScope + name)"
        :class="{'hide-tooltip' : bluredProp !== name, 'big-size' : bigSize, 'middle-size' : middleSize, 'small-size' : smallSize}"
      >
        <div class="text">
          {{ errors.first(calculatedScope + name) }}
        </div>
      </div>
    </div>
    <!-- Input with no validation-->
    <div class="input-wrapper input-field" v-if="!validateProp">
      <input
        type="text"
        :placeholder="placeholder"
        class="input"
        :class="name"
        v-model="search"
        :disabled="!disabledProp"
        @input="onChange"
        @click="onClick"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        @keydown.tab="onTabClick"
        readonly="readonly"
        :name="name"
        autocomplete="off" />
      <span class="icon-wrapper" @click="onClickArrow" :class="name">
        <img class="icon" src='@/assets/images/arrow_down.png' :class="name" />
      </span>
    </div>
    <ul
      v-show="isOpen"
      class="autocomplete-results"
      :class="{name, 'autocomplete-results-longer': name === 'states' || name === 'interval' || name === 'repeatUnit' || name === 'endUnit' || name === 'bankInstitution'}"
      ref="scrollContainer"
    >
      <li
        v-for="(result, indexAutocomplete) in results"
        :key="`autocomplete-${indexAutocomplete}`"
        @click="setResult(result, name)"
        class="autocomplete-result"
        :class="{ 'is-active': indexAutocomplete === arrowCounter, 'italics': result === 'No entry found' }"
        ref="options"
      >
        <span v-if="result.name == null" @click="setResult(result, name)">{{ result }}</span>
        <span v-if="result.name != null && !paymentsProp" @click="setResult(result)">{{ result.name }}</span>
        <span v-if="result.shortenedName != null && paymentsProp" @click="setResult(result)">{{ result.shortenedName }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import vClickOutside from 'v-click-outside';

  export default {
    name: "autocomplete",
    inject: ['$validator'],
    props: {
      arrEditRecurring: {
        type: Array,
        default: () => []
      },
      items: {
        type: Array,
        required: true,
        default: () => []
      },
      placeholder: {
        type: String,
        required: false,
        default: () => ""
      },
      option: {
        type: Object,
        required: false,
        default: () => {}
      },
      name: {
        type: String,
        required: false,
        default: () => ""
      },
      scope: {
        type: String,
        required: false,
        default: () => ""
      },
      bluredProp: {
        type: String,
        required: false,
        default: () => ''
      },
      validateProp: {
        type: Boolean,
        required: false,
        default: () => true
      },
      bigSize: {
        type: Boolean,
        required: false,
        default: () => false
      },
      middleSize: {
        type: Boolean,
        required: false,
        default: () => false
      },
      smallSize: {
        type: Boolean,
        required: false,
        default: () => false
      },
      disabledProp: {
        type: Boolean,
        required: false,
        default: () => true
      },
      paymentsProp: {
        type: Boolean,
        required: false,
        default: () => false
      }
    },
    data() {
      return {
        search: "",
        results: [],
        isOpen: false,
        isResultOpen: false,
        isLoading: false,
        arrowCounter: -1,
        validateField: false,
        calculatedScope: '',
      };
    },
    directives: {
      clickOutside: vClickOutside.directive,
    },
    watch: {
      option: function(val) {
        if (val !== {} && val.name !== undefined) {
          this.setResult(val)
        }
      }
    },
    mounted() {
      document.addEventListener("click", this.handleClickOutside);
      this.$validator.resume();

      if (this.option != null && this.option.name) {
        if (this.option.shortenedName) {
          this.search = this.option.shortenedName;
        } else {
          this.search = this.option.name;
        }
      }
      if (this.scope !== '') {
        this.calculatedScope = this.scope + '.'
      }
    },
    destroyed() {
      document.removeEventListener("click", this.handleClickOutside);
      this.$validator.pause();
    },
    methods: {
      /**
       * @description On input field click set the values inside dropdown
       * @param e
       */
      onClick(e) {
        this.setValidateField()
        this.isOpen = true;
        this.filterResults();
        // If we are sending data on Edit recurring payment from FPAddPaymentsLayout
        if (this.arrEditRecurring.length) {
          this.results = this.arrEditRecurring
        } else {
          this.results = this.items
        }
        this.$emit("clearInputErrors", e);
        this.isResultOpen = true;
      },
      /**
       * @description On input arrow image click set the values inside dropdown
       */
      onClickArrow() {
        if (this.disabledProp) {
          this.setValidateField()
          this.isOpen = !this.isOpen;
          this.filterResults();
          // If we are sending data on Edit recurring payment from FPAddPaymentsLayout
          if (this.arrEditRecurring.length) {
            this.results = this.arrEditRecurring
          } else {
            this.results = this.items
          }
        }
      },
      onChange() {
        this.filterResults();
        this.optionChanged(this.search)
      },
      filterResults() {
        this.results = this.items.filter(
            item => item.name != null ? (item.name.toLowerCase().indexOf(this.search.toString().toLowerCase()) > -1) : ( item.toLowerCase().indexOf(this.search.toString().toLowerCase()) > -1)
        );
        if (this.results.length === 0) {
          this.results.push("No entry found")
        }
      },
      setResult(result) {
        if (result === 'No entry found' || result.name === 'No entry found') {
          this.isOpen = true;
          this.optionChanged(result);
        } else {
          if (result.name != null && !this.paymentsProp) {
            this.search = result.name;
          } else if (result.shortenedName != null && this.paymentsProp) {
            this.search = result.shortenedName;
          } else {
            this.search = result;
          }
          this.isOpen = false;
          this.$validator.errors.remove(this.name, this.scope);
          this.optionChanged(result);
        }
      },
      onArrowDown() {
        if (this.arrowCounter < this.results.length) {
          this.arrowCounter = this.arrowCounter + 1;
          this.fixScrolling();
        }
      },
      onArrowUp() {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter - 1;
          this.fixScrolling();
        }
      },
      fixScrolling(){
        if(this.$refs.options[this.arrowCounter]) {
          const liH = this.$refs.options[this.arrowCounter].clientHeight;
          this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
        }
      },
      onTabClick(e) {
        if (!this.isOpen) {
          this.onClick(e);
        } else {
          this.isOpen = false;
          this.arrowCounter = -1;
        }
      },
      onEnter(e) {
        this.search = this.results[this.arrowCounter].name;
        this.optionChanged(this.results[this.arrowCounter]);
        this.isOpen = false;
        this.arrowCounter = -1;
        e.target.blur();
      },
      handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
          this.isOpen = false;
          this.arrowCounter = -1;
        }
      },
      optionChanged(value) {
        this.$emit("optionChanged", value);
        this.$validator.errors.remove(this.name);
      },
      clear() {
        this.search = ''
      },
      clearInputErrors(e) {
        this.onClick(e);
        this.$emit("clearInputErrors", e);
      },
      clearOthers(e) {
        this.$emit("clearOthers", e);
      },
      onOutsideClick() {
        if (this.validateProp && this.isResultOpen) {
          if (this.search === '') {
            this.createError()
          } else {
            if (this.name !== 'bankInstitution') {
              this.$validator.errors.remove(this.name, this.scope)
            } else {
              if (this.search.id !== undefined) {
                this.$validator.errors.remove(this.name, this.scope)
              }
            }
          }
          this.isResultOpen = false;
        }
      },
      // onOutsideClickModal(name, bluredPropParam) {
      //   setTimeout(() => document.getElementById(name).addEventListener('click', (e) => {
      //     let input = document.querySelector('.input.' + this.name);
      //     let iconWrapper = document.querySelector('.icon-wrapper.' + this.name);
      //     let icon = document.querySelector('.icon.' + this.name);
      //     let dropdown = document.querySelector('.autocomplete-results.' + this.name);
      //     let result = document.querySelector('.autocomplete-result.' + this.name);
      //     let clickedElement = e.target;
      //
      //     if (clickedElement !== input && clickedElement !== iconWrapper && clickedElement !== icon && clickedElement !== dropdown && clickedElement !== result) {
      //       if (this.search === '' && this.bluredProp === bluredPropParam) {
      //         this.createError()
      //       }
      //     } else {
      //       this.$validator.errors.remove(this.calculatedScope + this.name)
      //     }
      //   }), 0);
      // },
      setValidateField() {
        this.validateField = true
      },
      createError() {
        // errorMsg placeholder "Please select valid" + "Co-Parent" or "name of input" + "."
        let errorMsg = this.$lang.messages.vee_selectValidField +
            (this.name === 'coparent' ? this.$lang.messages.coParent : this.name === 'bankInstitution' ? this.$lang.messages.bankInstitution.toLowerCase() : this.name) +
            (this.name === 'bankInstitution' ? ' from the offered list' : '') +
            '.';
        this.$validator.errors.add({
          field: this.name,
          scope: this.scope,
          msg: errorMsg
        });
        this.setValidateField();
      }
    },
  };
</script>
